module.exports = __webpack_public_path__ + "img/almost.6fb5baa3.png";